// import { useLocation } from "react-router-dom";
// import { useRecoilValue } from "recoil";
// import { barreDefilement } from "../services/atom";

const HeaderScroll = () => {
  // const hauteurScroll = useRecoilValue(barreDefilement);
  // const location = useLocation();

  return (
    <>
      <img
        src={process.env.PUBLIC_URL + "/images/profil-1.jpg"}
        alt="profile"
        className={`rounded-full object-cover transition-all border-[#1f2d32] border-4 w-16 h-16 lg:w-52 lg:h-52 mobile-m:w-16 mobile-m:h-16`}
      />

      <div className="flex -space-x-1 items-center text-3xl tracking-tighter font-[Yanone Kaffeesatz] text-[#c3e88d] font-semibold md:text-5xl">
        <span>
          <img className="h-9 w-9 md:h-11 md:w-11" src={process.env.PUBLIC_URL + "/logo-portfolio-a.svg"} alt="logo" />
        </span>
        <span className="text-sous-titre-vert mt-2.5 md:mt-1.5">mara Fofana</span>
      </div>
    </>
  );
};

export default HeaderScroll;
